var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.calculated
    ? _c(
        "span",
        { staticClass: "d-flex align-items-center justify-content-between" },
        [
          _vm._v(_vm._s(_vm.formattedValue || "0.00") + "\n  "),
          _vm.loading ? _c("inline-loader") : _vm._e(),
        ],
        1
      )
    : _c("input", {
        directives: [
          {
            name: "mask",
            rawName: "v-mask",
            value: _vm.mask,
            expression: "mask",
          },
        ],
        ref: "input",
        attrs: {
          type: "text",
          name: _vm.name,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
        },
        domProps: { value: _vm.value },
        on: { change: _vm.handleChange },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }